export const EMAIL = {
  EMAIL_REGEX:
    '^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)[\\w!#$%&‘*+-\\/=?^`.{|}~]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,}$'
};
